module.exports = __webpack_public_path__ + "static/media/dateIcon-img.29f2c2fd.svg";